// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import { ModalHandlersContext, ModalPropsContext } from './../../context'

import { ChevronLeftIcon } from 'components/shared/Icon/Icon'

import styles from './Footer.module.scss'

export const Footer = ({
  className = undefined,
  customControls = undefined,
}) => {
  const { onBack, onCancel, onConfirm } = React.useContext(ModalHandlersContext)
  const {
    backLabel,
    cancelLabel,
    confirmIcon,
    confirmLabel,
    isConfirmDisabled,
  } = React.useContext(ModalPropsContext)

  return (
    <footer className={cx(styles.footer, { [className]: Boolean(className) })}>
      {backLabel ? (
        <Button
          icon={ChevronLeftIcon}
          label={backLabel}
          size="medium"
          variant="text"
          onClick={onBack}
        />
      ) : null}
      <div className={styles.actions}>
        {customControls}
        {cancelLabel ? (
          <Button
            className={styles.cancel}
            label={cancelLabel}
            size="medium"
            variant="outlined"
            onClick={onCancel}
          />
        ) : null}
        {confirmLabel ? (
          <Button
            className={styles.confirm}
            color="primary"
            icon={confirmIcon}
            label={confirmLabel}
            size="medium"
            variant="filled"
            onClick={onConfirm}
            isDisabled={isConfirmDisabled}
          />
        ) : null}
      </div>
    </footer>
  )
}
